import Head from 'next/head';
import { NextPage } from 'next';
import getConfig from 'next/config';

import {
  SignupDetails,
} from '@/core/interfaces/common';
import { wrapper } from '@/core/store/store';

import { ContactFormV4 } from '@/features/ContactFormV4';
import { SignupForm } from '@/features/SignupForm';

import { fetchSingupData } from '@/utils/requestHelpers';

import ErrorPage from '../404';

interface SignupProps {
  signupDetails?: SignupDetails;
}

const { REACT_APP_LANDING_VERSION } = getConfig().publicRuntimeConfig;

const SignupPage: NextPage<SignupProps> = (initialProps: SignupProps) => {
  const {
    signupDetails,
  } = initialProps;

  if (!signupDetails) {
    return (
      <>
        <Head>
          <meta
            name="robots"
            content="noindex"
          />
        </Head>
        <ErrorPage />
      </>
    );
  }

  const title = `${signupDetails.headlineConfig.headlineText || 'Sign up'} | ${signupDetails.organization.name}`;

  const renderLandingPage = (version: string) => {
    switch (version) {
      case 'version4':
        return (
          <ContactFormV4 signupDetails={signupDetails} />
        );
      default:
        return (
          <SignupForm signupDetails={signupDetails} />
        );
    }
  };

  return (
    <>
      <Head>
        <title key="title">{title}</title>
        <meta
          property="og:title"
          content={title}
        />
        <meta
          property="og:image"
          content={signupDetails.signupPageImage}
        />
        {signupDetails.headlineConfig.secondHeadlineText && (
          <>
            <meta
              name="description"
              content={signupDetails.headlineConfig.secondHeadlineText}
            />
            <meta
              property="og:description"
              content={signupDetails.headlineConfig.secondHeadlineText}
            />
          </>
        )}
      </Head>

      {renderLandingPage(REACT_APP_LANDING_VERSION || signupDetails.version)}
    </>
  );
};

SignupPage.getInitialProps = wrapper.getInitialPageProps(() => async ({
  query,
  req,
  res,
}) => {
  const signupDetails = await fetchSingupData(query.uuid, req);

  if (res && !signupDetails) {
    res.statusCode = 404;
  }

  return {
    signupDetails,
  };
});

export default SignupPage;
